import React from 'react';
import PropTypes from 'prop-types';
import ModalTriggerComponent from '../../modal/js/modal-trigger.component';

export default class PopupLink extends React.Component {
    constructor(props) {
        super(props);

        this.linkRef = React.createRef();
    }

    componentDidMount() {
        this.modalTrigger = new ModalTriggerComponent(this.linkRef.current, 'modal-trigger');
    }

    componentWillUnmount() {
        this.modalTrigger.destroy();
    }

    render() {
        return (
            <button ref={this.linkRef}
                className={this.props.className}
                type="button"
                data-dc-component="modal-trigger"
                data-dc-modal-trigger-href={this.props.href}
                aria-label={this.props.ariaLabel}>
                <span className="button-content button-content--icon">
                    {this.props.children}
                </span>
            </button>
        );
    }
}

PopupLink.propTypes = {
    className: PropTypes.string,
    href: PropTypes.string,
    ariaLabel: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};
